import { render, staticRenderFns } from "./NotificationsAdmin.vue?vue&type=template&id=a93b0660&"
import script from "./NotificationsAdmin.vue?vue&type=script&lang=js&"
export * from "./NotificationsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports